var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kst-section',{attrs:{"collapsed":"","info-mode":"","collapsible":_vm.isCollapsible,"help-collapsed":_vm.sectionHelp,"help":_vm.sectionHelp,"title":_vm.sectionTitle}},[_c('kst-output',{attrs:{"field":"RefID","data":_vm.details,"catalog":_vm.Catalog}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }